import React from "react";
import { Formik } from "formik";

const SosEtaForm = (props) => {
  return (
    <Formik initialValues={props.initial} onSubmit={props.onSubmit}>
      {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label htmlFor="eta_sos" className="label">
              Fuente de suministro
            </label>
            <div className="control">
              <input
                id="eta_sos"
                name="sos"
                type="text"
                className="input"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.sos}
              />
            </div>
          </div>

          <div className="field">
            <label htmlFor="eta_shipping_type" className="label">
              Código de envío
            </label>
            <div className="control">
              <input
                id="eta_shipping_type"
                name="shipping_type"
                type="text"
                className="input"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.shipping_type}
              />
            </div>
          </div>

          <div className="field">
            <label htmlFor="eta_description" className="label">
              Descripción
            </label>
            <div className="control">
              <input
                id="eta_description"
                name="description"
                type="text"
                className="input"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.description}
              />
            </div>
          </div>

          <div className="field">
            <label htmlFor="eta_estimated_days" className="label">
              ETA (Tiempo estimado de entrega en días naturales)
            </label>
            <div className="control">
              <input
                id="eta_estimated_days"
                name="estimated_days"
                type="integer"
                className="input"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.estimated_days}
              />
            </div>
          </div>

          <div className="field is-grouped mt-5">
            <div className="control">
              <button
                type="submit"
                className="button is-primary"
                disabled={isSubmitting}
              >
                Enviar
              </button>
            </div>
            {props.onCancel ? (
              <div className="control">
                <button
                  type="button"
                  className="button is-text"
                  onClick={props.onCancel}
                >
                  Cancelar
                </button>
              </div>
            ) : null}
          </div>
        </form>
      )}
    </Formik>
  );
};

export default SosEtaForm;
